var render, staticRenderFns
import script from "./input.vue?vue&type=script&lang=tsx&"
export * from "./input.vue?vue&type=script&lang=tsx&"
import style0 from "./input.vue?vue&type=style&index=0&id=258847c5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258847c5",
  null
  
)

/* custom blocks */
import block0 from "../lang.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fworkspace%2Fsource-code%2Fcomponents%2Fdu-input%2Fcomponents%2Finput.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports